module.exports = __webpack_public_path__ + "static/media/products_specification.7023962e.md";